export default defineNuxtPlugin(() => {
  const { status, data: session } = useAuth()
  const { transferGuestBudget, hasGuestBudgetToTransfer } = useBudgetTransfer()

  // Watch for authentication status changes
  watch(
    [status, session],
    async ([newStatus, newSession], [oldStatus]) => {
      // Only run on client side
      if (process.server) return

      // Check if user just logged in (status changed from unauthenticated to authenticated)
      if (
        newStatus === 'authenticated' && 
        oldStatus !== 'authenticated' && 
        newSession?.user?.id &&
        hasGuestBudgetToTransfer()
      ) {
        
        
        // Small delay to ensure the UI has fully loaded
        await nextTick()
        setTimeout(async () => {
          try {
            const result = await transferGuestBudget(newSession.user.id)
            
            if (result.success && result.transferred) {
              
              
              // Optional: Redirect to budgets page to show the transferred budget
              const router = useRouter()
              if (router.currentRoute.value.path === '/wizard') {
                await router.push('/budgets')
              }
            }
          } catch (error) {
            console.error('Failed to transfer guest budget:', error)
          }
        }, 1000) // 1 second delay to ensure everything is loaded
      }
    },
    { immediate: false }
  )
})
